import { EffectDef, makeGain } from './types';

/** Stereo chorus: two LFO-modulated delay taps. */
export const chorus: EffectDef = {
  type: 'chorus',
  name: 'Chorus',
  params: [
    { key: 'rate', label: 'Rate', min: 0.1, max: 8, default: 1.2, step: 0.1, unit: 'Hz' },
    { key: 'depth', label: 'Depth', min: 0, max: 1, default: 0.5, step: 0.01 },
    { key: 'wet', label: 'Wet', min: 0, max: 1, default: 0.4, step: 0.01 },
  ],
  build(ctx, p) {
    const input = makeGain(ctx, 1);
    const output = makeGain(ctx, 1);
    const dry = makeGain(ctx, 1 - p.wet);
    const wetIn = makeGain(ctx, 1);

    const delayL = ctx.createDelay(0.1);
    const delayR = ctx.createDelay(0.1);
    const lfoL = ctx.createOscillator();
    const lfoR = ctx.createOscillator();
    const lfoGainL = makeGain(ctx, 0);
    const lfoGainR = makeGain(ctx, 0);
    const wetOut = makeGain(ctx, p.wet);

    const base = 0.02;
    delayL.delayTime.value = base;
    delayR.delayTime.value = base;
    lfoL.frequency.value = p.rate;
    lfoR.frequency.value = p.rate;
    lfoL.start();
    lfoR.start();

    input.connect(dry);
    dry.connect(output);
    input.connect(wetIn);
    wetIn.connect(delayL);
    wetIn.connect(delayR);
    delayL.connect(wetOut);
    delayR.connect(wetOut);
    wetOut.connect(output);
    lfoL.connect(lfoGainL);
    lfoGainL.connect(delayL.delayTime);
    lfoR.connect(lfoGainR);
    lfoGainR.connect(delayR.delayTime);

    const apply = (params: Record<string, number>) => {
      lfoL.frequency.value = params.rate;
      lfoR.frequency.value = params.rate;
      lfoGainL.gain.value = params.depth * 0.008;
      lfoGainR.gain.value = params.depth * 0.008;
      dry.gain.value = 1 - params.wet;
      wetOut.gain.value = params.wet;
    };
    apply(p);

    return {
      input,
      output,
      update: apply,
      dispose: () => {
        try {
          lfoL.stop();
          lfoR.stop();
        } catch {
          /* already stopped */
        }
        lfoL.disconnect();
        lfoR.disconnect();
        lfoGainL.disconnect();
        lfoGainR.disconnect();
        delayL.disconnect();
        delayR.disconnect();
        dry.disconnect();
        wetIn.disconnect();
        wetOut.disconnect();
        input.disconnect();
        output.disconnect();
      },
    };
  },
};